import React from 'react'

function GoogleAnalytics() {
  const googleAnalyticsURL = 'https://analytics.google.com/analytics/web/?authuser=1#/p237280658/reports/intelligenthome'; 
  window.open(googleAnalyticsURL);
  window.history.back();
  return (
    <></>
  )
}

export default GoogleAnalytics